import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./profile.module.css";
import questionnaireDoctor from "../../images/questionnaire_doctor.png";
import { AppImage, AppVideo } from "../../components/appMedia";
import uploadIcon from "../../images/upload_icon.svg";
import React, { useEffect, useState } from "react";
import Modal from "../../components/modals/modal/Modal";
import ChangePasswordPopup from "../../components/modals/changePasswordPopup/changePasswordPopup";
import UpdateUserInfoSuccessPopup from "../../components/modals/updateUserInfoSuccessPopup/updateUserInfoSuccessPopup";
import useMediaQuery from "../../hooks/useMediaQuery";
import { useAppSelector } from "../../services/hooks";
import { errorUserSelector } from "../../services/selectors/auth.selectors";
import ChangeAvatarPopup from "../../components/modals/changeAvatarPopup/changeAvatarPopup";
import ChangeVideoPopup from "../../components/modals/changeVideoPopup/changeVideoPopup";
import { useFormik } from "formik";
import { updateUserValidationSchema } from "../../utils/validation";
import { mobileWidth, specializationAreas } from "../../utils/constants";
import {
  useLazyGetUserQuery,
  useTherapistsSpecializations2TherapistsDMLMutation,
  useTherapistsSpecializationsDMLMutation,
  useUpdateUserMutation,
  useUpdateTherapistInfoMutation,
} from "../../services/api/user.api";
import { getAllowedExternalVideoEmbedUrl, getChangedValues } from "../../utils/utils";
import {
  userSelector,
} from "../../services/selectors/user.selectors";
import Select, { ActionMeta, MultiValue, SingleValue } from "react-select";
import BackArrowButton from "../../components/backArrowButton/backArrowButton";
import { useNavigate } from "react-router-dom";
import Tooltip from "../../components/tooltip/tooltip";
import { AddLabelAndValue, TNamedItem } from "../../types/types";
import { useGetGendersQuery, useGetMigzarsQuery } from "../../services/api/user.api";
import { TSpecialization } from "../../services/types/user.types";
import i18n from "../../i18n";
import GeneralErrorPopup from "../../components/modals/errorPopup/errorPopup";

function ProfilePage() {
  const navigate = useNavigate();

  const user = useAppSelector(userSelector);
  const updateError = useAppSelector(errorUserSelector);

  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [openUserInfoModal, setOpenUserInfoModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openAvatarModal, setOpenAvatarModal] = useState(false);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [tooltipTarget, setTooltipTarget] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState<
    Partial<TSpecialization>[]
  >([]);
  const [groupedOptions, setGroupedOptions] = useState<
    {
      label: string;
      options: {
        value: number;
        label: string;
      }[];
    }[]
  >();

  const [getAllSpecializations] = useTherapistsSpecializationsDMLMutation();
  const [updateUser, { isError, error }] = useUpdateUserMutation();
  const [getUser] = useLazyGetUserQuery();
  const { data: migzars } = useGetMigzarsQuery();
  const { data: genders } = useGetGendersQuery();
  const [therapistsSpecializations2Therapists] =
    useTherapistsSpecializations2TherapistsDMLMutation();
  const migzarOptions: { value: number; label: string }[] =
    migzars?.map((option: any) => ({
      value: option.Id ?? option.id,
      label: option.Name ?? option.name,
    })) ?? [];

  const genderOptionsFromQuery: { value: number; label: string }[] =
    genders?.map((option: any) => ({
      value: option.Id ?? option.id,
      label: option.Name ?? option.name,
    })) ?? [];

  // utility: try to find an existing video URL in user object
  const getExistingUserVideoUrl = () => {
    // adapt to your actual user fields; check several possible fields
    return (
      (user && (user.videoUrl || user.videoPath || user.video || user.profileVideo)) ??
      user?.videoLink ??
      null
    );
  };

  // useEffect(() => {
  //   getUser();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    getAllSpecializations({
      list: [],
      type: 1,
      companyId: user.companyId,
    }).then((response) => {
      if ("data" in response && response.data) {
        const specializationsData = response.data;
        const groupedOptions = specializationAreas.map((area) => ({
          label: i18n.language && i18n.language.startsWith("en")
            ? area.nameEn
            : area.label,
          options: specializationsData
            .filter(
              (spec) => spec.therapistsSpecializationsTypesId === area.value
            )
            .map((spec) => ({
              value: spec.id,
              label: spec.name,
            })),
        }));
        setGroupedOptions(groupedOptions);
      }
    });
  }, [getAllSpecializations, user.companyId, i18n.language]);

  useEffect(() => {
    therapistsSpecializations2Therapists({
      list: [],
      type: 1,
      usersGuid: user.guid,
    });
  }, [therapistsSpecializations2Therapists, user.guid]);

  useEffect(
    () => {
      if (user.therapistSpecializations) {
        setSelectedOptions(
          user.therapistSpecializations
            .filter((spec) => spec.statusId !== 0)
            .map((spec) => ({
              therapistsSpecializationsTypesId:
                spec.therapistsSpecializationsId,
              name: getLabelByValue(spec.therapistsSpecializationsId || 0),
            }))
        );
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [user.therapistSpecializations, groupedOptions]
  );

  const handleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const onSelectChange = (
    value: SingleValue<AddLabelAndValue<TNamedItem>>,
    { name }: ActionMeta<AddLabelAndValue<TNamedItem>>
  ) => {
    if (value && name) {
      formik.setFieldValue(name, value.Id);
    }
  };
  const [sendAbout] = useUpdateTherapistInfoMutation();
  const handleSelectChange = (
    selected: MultiValue<{ value: number; label: string }>
  ) => {
    setSelectedOptions(
      selected.map((option) => ({
        therapistsSpecializationsTypesId: option.value,
        name: option.label,
      }))
    );
    setTouched(true);
  };
  const mobile = useMediaQuery(mobileWidth);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: user,
    validationSchema: updateUserValidationSchema,
    onSubmit: async (values) => {
      // Handle form submission
      if (values.about !== formik.initialValues.about) {
        sendAbout({ about: values.about || "" })
          .then(() => {
            setOpenUserInfoModal(true);
            getUser();
          })
          .catch(() => {
            // console.log("the about section was not updated");
          });
      }
      const { about: currentAbout, ...otherValues } = values;
      const { about: initialAbout, ...initialOtherValues } =
        formik.initialValues;

      const changedValues = getChangedValues(otherValues, initialOtherValues);
      if (Object.keys(changedValues).length > 0) {
        const body = Object.keys(changedValues).map((key) => {
          return {
            op: "replace",
            path: `/${key}`,
            value: changedValues[key],
          };
        });
        updateUser({ body, guid: user.guid }).then((response) => {
          if ("data" in response && response.data) {
            setOpenUserInfoModal(true);
            getUser();
          } else {
            setOpenErrorModal(true);
          }
        });
      }
      touched &&
        therapistsSpecializations2Therapists({
          list: selectedOptions.map((selected) => ({
            id: 0,
            statusId: 1,
            therapistsSpecializationsId:
              selected.therapistsSpecializationsTypesId || 0,
            usersId: 0,
          })),
          type: 2,
          usersGuid: user.guid,
        });
    },
  });

  const getLabelByValue = (value: number) => {
    for (const group of groupedOptions ?? []) {
      const found = group.options.find((opt) => opt.value === value);
      if (found) return found.label;
    }
    return "";
  };

  const isFormChanged = formik.dirty || touched;

  return (
    <div className={styles.profile} dir={i18n.dir()}>
      {openPasswordModal && (
        <Modal onClose={() => setOpenPasswordModal(false)}>
          <ChangePasswordPopup onClose={() => setOpenPasswordModal(false)} />
        </Modal>
      )}
      {openUserInfoModal && (
        <Modal onClose={() => setOpenUserInfoModal(false)}>
          <UpdateUserInfoSuccessPopup
            onClose={() => setOpenUserInfoModal(false)}
          />
        </Modal>
      )}
      {openAvatarModal && (
        <Modal onClose={() => setOpenAvatarModal(false)}>
          <ChangeAvatarPopup onClose={() => setOpenAvatarModal(false)} />
        </Modal>
      )}
      {openVideoModal && (
        <Modal onClose={() => setOpenVideoModal(false)}>
          <ChangeVideoPopup onClose={() => setOpenVideoModal(false)} />
        </Modal>
      )}
      <BackArrowButton
        text={t("PROFILE_BACK_BUTTON")}
        onClick={() => navigate(-1)}
        position={"center"}
      />

      <div className={styles.profile__content}>
        <h2 className={styles.profile__title}>
          {t("PROFILE_ACCOUNT_DETAILS")}
        </h2>
        <AppImage
          onClick={handleModal}
          src={user.avatar ? user.avatar : questionnaireDoctor}
          alt={t("EDIT_PERSONAL_DATA_USER_AVATAR_ALT")}
          className={styles.profile__avatarPlaceholder}
        />
        {isModalOpen && (
          <div className={styles.profile__Modal} onClick={handleModal}>
            <AppImage
              className={styles.profile__ModalContent}
              src={user.avatar ? user.avatar : questionnaireDoctor}
              alt="Profile Full"
            />
          </div>
        )}

        <div
          onMouseEnter={() => setTooltipTarget("pic")}
          onMouseLeave={() => setTooltipTarget(null)}
          style={{ position: "relative", display: "inline-block" }}
        >
          <button
            type="button"
            className={`${styles.profile__addAvatar} ${
              mobile && styles.profile__addAvatar_mobile
            }`}
            onClick={() => setOpenAvatarModal(true)}
          />
          {tooltipTarget === "pic" && (
            <div className={styles.tooltip}>
              <Tooltip isShown={true} position="left">
                {t('EDIT_PROFILE_PICTURE')}</Tooltip>
            </div>
          )}
        </div>
        {user.account && (
          <p className={styles.profile__accountNumber}>
            {t("PROFILE_USER_NUMBER")} {user.account}
          </p>
        )}
      </div>
      <form
        id="updateUser"
        onSubmit={formik.handleSubmit}
        className={styles.profile__form}
      >
        <ul className={styles.profile__list}>
          <li>
            <label htmlFor="firstName" className={styles.profile__label}>
              {t("PROFILE_FIRST_NAME")}
            </label>
            <input
              type="text"
              className={`${styles.profile__input} ${
                formik.errors.firstName && styles.profile__input_invalid
              }`}
              name="firstName"
              id="firstName"
              value={formik.values.firstName ?? ""}
              maxLength={50}
              onChange={(e) => {
                const onlyLetters = e.target.value.replace(
                  /[^A-Za-zא-ת0-9\s\-]/g,
                  ""
                );
                formik.setFieldValue("firstName", onlyLetters);
              }}
              onBlur={formik.handleBlur}
            />
          </li>
          <li>
            <label htmlFor="lastName" className={styles.profile__label}>
              {t("PROFILE_LAST_NAME")}
            </label>
            <input
              type="text"
              className={`${styles.profile__input} ${
                formik.errors.lastName && styles.profile__input_invalid
              }`}
              name="lastName"
              id="lastName"
              value={formik.values.lastName ?? ""}
              onChange={(e) => {
                const onlyLetters = e.target.value.replace(
                  /[^A-Za-zא-ת0-9\s\-]/g,
                  ""
                );
                formik.setFieldValue("lastName", onlyLetters);
              }}
              onBlur={formik.handleBlur}
            />
          </li>
          <li>
            <label htmlFor="degree" className={styles.profile__label}>
              {t("PROFILE_DEGREE")}
            </label>
            <input
              readOnly={true}
              type="text"
              className={`${styles.profile__input} ${
                formik.errors.degree && styles.profile__input_invalid
              }`}
              name="degree"
              id="degree"
              // value={formik.values.roles?.Name ?? ""}
              // onChange={formik.handleChange}
              // onBlur={formik.handleBlur}
            />
          </li>
          <li>
            <label htmlFor="email" className={styles.profile__label}>
              {t("PROFILE_EMAIL")}
            </label>
            <input
              type="email"
              className={`${styles.profile__input} ${
                formik.errors.email && styles.profile__input_invalid
              }`}
              name="email"
              id="email"
              value={formik.values.email ?? ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </li>
          <li>
            <label htmlFor="vetek" className={styles.profile__label}>
              {t("PROFILE_YEARS_OF_EXPERIENCE")}
            </label>
            <input
              type="number"
              className={styles.profile__input}
              name="vetek"
              id="vetek"
              min="0"
              inputMode="numeric"
              value={formik.values.vetek ?? ""}
              onKeyDown={(e) => {
                if (["-", "e", "E", "+", "."].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const value = e.target.value;
                if (
                  value === "" ||
                  (/^\d+$/.test(value) && Number(value) >= 0)
                ) {
                  formik.setFieldValue(
                    "vetek",
                    value === "" ? "" : Number(value)
                  );
                }
              }}
              onBlur={formik.handleBlur}
            />
          </li>
          <li>
            <label htmlFor="migzar" className={styles.profile__label}>
              {t("PROFILE_SECTOR")}
            </label>
            <Select
              classNamePrefix="mySelect"
              id="migzar"
              name="migzarId"
              placeholder={t("PLACEHOLDER_SELECT_SECTOR")}
              options={migzarOptions}
              value={
                migzarOptions.find(
                  (option) => option.value === formik.values.migzarId
                ) || null
              }
              className={styles.select}
              onChange={(selectedOption) => {
                formik.setFieldValue("migzarId", selectedOption?.value || null);
              }}
            />
          </li>

          <li>
            <label htmlFor="gender" className={styles.profile__label}>
              {t("PROFILE_GENDER")}
            </label>
            <Select
              classNamePrefix="mySelect"
              id="gender"
              name="genderId"
              placeholder={t("PLACEHOLDER_SELECT_GENDER")}
              options={genderOptionsFromQuery}
              value={
                genderOptionsFromQuery.find(
                  (option) => option.value === formik.values.genderId
                ) || null
              }
              className={styles.select}
              onChange={(selectedOption) => {
                formik.setFieldValue("genderId", selectedOption?.value || null);
              }}
            />
          </li>
          <li>
            <label htmlFor="phone" className={styles.profile__label}>
              {t("PROFILE_PHONE")}
            </label>
            <input
              type="tel"
              className={`${styles.profile__input} ${
                formik.errors.phone && styles.profile__input_invalid
              }`}
              name="phone"
              id="phone"
              value={formik.values.phone ?? ""}
              onChange={(e) => {
                const sanitized = e.target.value.replace(/[^+\d]/g, "");
                if (/^\+?\d*$/.test(sanitized) && sanitized.length <= 16) {
                  formik.setFieldValue("phone", sanitized);
                }
              }}
              onBlur={formik.handleBlur}
              placeholder={formik.values.phone}
            />
          </li>
          <li>
            <div className={styles.profile__info}>
              <span className={styles.profile__label}>
                {t("PROFILE_PASSWORD")}
              </span>
              <button
                type="button"
                onClick={() => {
                  setOpenPasswordModal(true);
                }}
                className={styles.profile__changeBtn}
              >
                {mobile ? "" : t("PROFILE_EDIT_PASSWORD")}
              </button>
            </div>
            <p
              className={`${styles.profile__input} ${styles.profile__password}`}
            >
              {[1, 2, 3, 4, 5, 6, 7, 8].map((circle, index) => (
                <span key={index} className={styles.profile__circle} />
              ))}
            </p>
          </li>
          <li>
            <label
              htmlFor="allSpecializations"
              className={styles.profile__label}
            >
              {t("SPECIALTY_AREAS")}
            </label>
            <Select
              isMulti={true}
              name="allSpecializations"
              placeholder={t("ACTION_REPORT_SELECT_PLACEHOLDER")}
              options={groupedOptions}
              className={styles.select}
              classNamePrefix="select"
              onChange={handleSelectChange}
              value={selectedOptions.map((option) => ({
                value: option.therapistsSpecializationsTypesId || 0,
                label: option.name || "",
              }))}
              isOptionDisabled={(option) =>
                selectedOptions.some(
                  (selected) => selected.name === option.label
                )
              }
            />
          </li>
          <li>
            <label htmlFor="about" className={styles.profile__label}>
              {t("PROFILE_ABOUT_ME")}
            </label>
            <textarea
              className={`scroll ${styles.profile__input} ${
                styles.profile__textArea
              } ${styles.height_unset} ${
                formik.errors.about && styles.profile__input_invalid
              }`}
              maxLength={3000}
              name="about"
              id="about"
              value={formik.values.about || ""} // <-- קורא ישירות מ-formik
              onChange={formik.handleChange} // <-- מעדכן את formik
              onBlur={formik.handleBlur}
              placeholder={formik.values.about}
            />
          </li>
          <li className={styles.profile__videoSection}>
            <label
              className={`${styles.profile__label} ${styles.profile__label_video}`}
            >
              <button
                type="button"
                className={styles.profile__videoBtn}
                onClick={() => setOpenVideoModal(true)}
                aria-haspopup="dialog"
              >
                 {user?.video 
                    ? t("PROFILE_VIDEO_LABEL_EXISTING") // כשכבר קיים סרטון
                    : t("PROFILE_VIDEO_LABEL")          // כשאין סרטון
                  }
                <img
                  src={uploadIcon}
                  alt={t("PROFILE_VIDEO_UPLOAD_ALT")}
                  className={styles.profile__uploadBtn}
                />
              </button>
            </label>

            {/* PREVIEW AREA */}
            {user?.video &&(<div
              className={styles.profile__videoPreviewContainer}
              
            >
              {getExistingUserVideoUrl() ? (
                getAllowedExternalVideoEmbedUrl(getExistingUserVideoUrl()!) ? (
                  <div className={styles.profile__iframeWrapper}>
                    <iframe
                      title="Video preview"
                      src={getAllowedExternalVideoEmbedUrl(getExistingUserVideoUrl()!)!}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className={styles.profile__iframe}
                    />
                  </div>
                ) : (
                  <AppVideo
                    src={getExistingUserVideoUrl()!}
                    controls
                    className={styles.profile__video}
                  />
                )
              ) : null}
            </div>)}
          </li>
        </ul>
      </form>
      {formik.errors && (
        <p className={`${styles.profile__invalid_message}`}>
          {t(
            formik.errors.firstName ??
              formik.errors.lastName ??
              formik.errors.email ??
              formik.errors.phone ??
              formik.errors.address
          )}
        </p>
      )}
      {isError && (
        <p className={`${styles.profile__invalid_message}`}>{updateError || t("ERROR_POPUP_DEFAULT_TEXT")}</p>
      )}
      <button
        type={"submit"}
        form={"updateUser"}
        disabled={!isFormChanged || !formik.isValid || formik.isSubmitting}
        className={`button ${!mobile && "button_white"} hover ${styles.btn} ${
          (!isFormChanged || !formik.isValid || formik.isSubmitting) &&
          styles.btn_disabled
        }`}
      >
        {isFormChanged ? (
          <span style={{ padding: "0 34px" }}>
            {t("ADD_RECOMMENDATION_SAVE_BUTTON")}
          </span>
        ) : (
          <span>{t("PROFILE_EDIT_ACCOUNT_DETAILS")}</span>
        )}
      </button>
    </div>
  );
}

export default ProfilePage;
